import ReferralScreen from "../components/referral/referral";

const Referral = () => {
  return <ReferralScreen />;
};

export default Referral;
